import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { storeToRefs } from 'pinia';

import { TitleDetail } from '@/interfaces/title-details-graphql';
import adminConfig from '@/features/promotions/config.json';
import { getOffersForCountry } from '@/helpers/offer-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

const BINGE_SUBGENRES = ['dred', 'myst', 'thht'];

type YieldOptimzationPromotion = { provider: string; placement: 'ft' };

// update config.json output to show Binge FT on certain titles, and override AdServer from components
export function getBingeTargeting(title: TitleDetail, country: string): YieldOptimzationPromotion | null {
	if (country !== 'AU') return null;
	if (!adminConfig?.steering_overrides_global?.binge_subgenre_targeting_au) return null;

	// exclude ATV titles
	if (getOffersForCountry(title.offers, country).some(o => o.package.shortName === 'atp')) return null;

	const hasBingeTargeting = (title.content.subgenres ?? []).some(s =>
		BINGE_SUBGENRES.includes(s.content.shortName || '')
	);

	return hasBingeTargeting ? { provider: 'bng', placement: 'ft' } : null;
}

export function useBingeTargeting(title: MaybeRefOrGetter<TitleDetail>) {
	const { country } = storeToRefs(useLanguageStore());

	const isBingeFTOverrideAU = computed(() => !!getBingeTargeting(toValue(title), country.value));
	return { isBingeFTOverrideAU };
}
